import { getNewsCounters } from 'helpers/web_to_client'

export const CLIENT_COUNTERS_LOAD_REQUEST = 'client/counters/REQUEST'
export const CLIENT_COUNTERS_LOAD_SUCCESS = 'client/counters/SUCCESS'
export const CLIENT_COUNTERS_LOAD_ERROR = 'client/counters/ERROR'

export function clientCountersRequestStart() {
    return {
        type: CLIENT_COUNTERS_LOAD_REQUEST,
    }
}

export function clientCountersRequestSuccess(data) {
    return {
        type: CLIENT_COUNTERS_LOAD_SUCCESS,
        payload: data,
    }
}

export function clientCountersRequestError(errorData) {
    return {
        type: CLIENT_COUNTERS_LOAD_ERROR,
        payload: errorData,
    }
}

export function requestClientCounters() {
    return async (dispatch) => {
        try {
            dispatch(clientCountersRequestStart())
            const { news_counts } = await getNewsCounters()
            dispatch(clientCountersRequestSuccess(news_counts))
        } catch (errorData) {
            // eslint-disable-next-line no-console
            console.error('>> WGSH cannot request counters info', errorData)
            dispatch(clientCountersRequestError({ errorMessage: errorData.message }))
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/client_counters.js